import React from 'react';
import PropTypes from 'prop-types';
import styles from '../ArticleComponents.module.css';
import JSXStyle from 'styled-jsx/style';

export default function ButtonComponent({ id, component, style }) {
	const { text, font_size, externallinktarget, link, align } = component;
	let alignment = 'center';

	if (!Array.isArray(style)) {
		let stylesArray = [];
		for (const k in style) {
			stylesArray.push(style[k]);
		}

		style = stylesArray;
	}

	let buttonStyles = style.filter((s) => s.id === component.style);
	let buttonStyle = {
		fontFamily: null,
		fontSize: font_size ? `${font_size}em` : '1rem',
		background: '#fff',
		color: '#000',
		marginBottom: 0,
		marginTop: 0,
		padding: 0,
		css: null,
		borderRadius: '0.3em',
		border: 0,
	};

	// Style properties
	if (buttonStyles.length && buttonStyles[0]) {
		const {
			font_family,
			color,
			letter_spacing,
			line_height,
			margin_bottom,
			margin_top,
			font_size,
			size,
			css
		} = buttonStyles[0];

		if (font_family) {
			buttonStyle.fontFamily = font_family;
		}

		if (color) {
			buttonStyle.color = `#${color.replace(
				'#',
				''
			)}`;
		}

		if (buttonStyles[0]['bg-color']) {
			buttonStyle.background = `#${buttonStyles[0]['bg-color'].replace(
				'#',
				''
			)}`;
		}

		if (buttonStyles[0]['case']) {
			buttonStyle.textTransform = buttonStyles[0]['case'];
		}

		if (font_size) {
			buttonStyle.fontSize = `${font_size}em`;
		}

		if (letter_spacing) {
			buttonStyle.letterSpacing = `${letter_spacing}em`;
		}

		if (line_height) {
			buttonStyle.lineHeight = `${line_height}`;
		}

		if (margin_bottom) {
			buttonStyle.marginBottom = `${Math.ceil(
				parseFloat(`${margin_bottom}`)
			)}px`;
		}

		if (margin_top) {
			buttonStyle.marginTop = `${Math.ceil(
				parseFloat(`${margin_top}`)
			)}px`;
		}

		if(css) {
			buttonStyle.css = css;
		}

		if (size) {
			switch (size) {
				case 'xsmall':
					buttonStyle.padding = '2px 5px';
					break;
				case 'small':
					buttonStyle.padding = `5px 10px`;
					break;
				case 'medium':
					buttonStyle.padding = `8px 18px`;
					break;
				case 'large':
					buttonStyle.padding = `12px 30px`;
					break;
				case 'xlarge':
					buttonStyle.padding = `14px 40px`;
					break;
			}
		}
	}

	// COMPONENT PROPERTIES
	if (align === 'left') {
		alignment = 'flex-start';
	} else if (align === 'right') {
		alignment = 'flex-end';
	}

	let componentCSS = buttonStyle.css ? `
		.jsx-${id} {
			${buttonStyle.css}
		}
	` : '';

	return (
		<div
			className={styles['component-button']}
			style={{ justifyContent: alignment }}
		>
			<button
				className={`jsx-${id}`}
				style={buttonStyle}
				onClick={() => {
					if (externallinktarget === 'on' && link) {
						window.open(link, '_blank');
					}
				}}
			>
				{text}
			</button>
			<JSXStyle id={id}>{componentCSS}</JSXStyle>
		</div>
	);
}

ButtonComponent.propTypes = {
	id: PropTypes.string.isRequired,
	component: PropTypes.object.isRequired,
	style: PropTypes.any,
};
